import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row col-md-12" }
const _hoisted_2 = { class: "row col-md-12" }
const _hoisted_3 = { class: "col-md-9" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-dialog-title" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "p-dialog-title" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = {
  class: "d-flex justify-content-end",
  style: {"align-items":"center"}
}
const _hoisted_10 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_11 = {
  key: 0,
  class: "col-md-12 d-flex justify-content-end"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "col-md-12 d-flex justify-content-end"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_16 = { class: "col-md-12 d-flex justify-content-end" }
const _hoisted_17 = { class: "row col-md-12" }
const _hoisted_18 = { class: "col-md-12 pt-2 pb-0" }
const _hoisted_19 = { class: "row col-md-12" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex justify-content-center align-items-start"
}
const _hoisted_21 = { class: "m-0" }
const _hoisted_22 = {
  class: "p-template-stick-header",
  style: {"top":"0"}
}
const _hoisted_23 = { class: "d-flex" }
const _hoisted_24 = { class: "p-row-title-text" }
const _hoisted_25 = { class: "p-column-title-text" }
const _hoisted_26 = {
  key: 0,
  class: "p-column-title-header"
}
const _hoisted_27 = {
  key: 0,
  style: {"width":"max-content","position":"sticky","left":"0","z-index":"99"}
}
const _hoisted_28 = { class: "p-row-title-text" }
const _hoisted_29 = {
  key: 0,
  class: "p-row-title-header"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "d-flex" }
const _hoisted_32 = {
  key: 0,
  class: "m-0"
}
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = { class: "p-row-title-text" }
const _hoisted_35 = {
  key: 0,
  class: "p-row-title-header"
}
const _hoisted_36 = { class: "p-column-title-text" }
const _hoisted_37 = {
  key: 0,
  class: "p-column-title-header"
}
const _hoisted_38 = {
  class: "p-cell-body-component",
  style: {"width":"calc(100% - 1.7rem)"}
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["onFocusin"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = { key: 5 }
const _hoisted_47 = { key: 6 }
const _hoisted_48 = { key: 7 }
const _hoisted_49 = { key: 8 }
const _hoisted_50 = { key: 9 }
const _hoisted_51 = { key: 10 }
const _hoisted_52 = { key: 11 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 0,
  class: "p-cell-body-menu",
  style: {"width":"1.5rem"}
}
const _hoisted_55 = {
  key: 0,
  class: "p-cell-body-menu-item-top"
}
const _hoisted_56 = {
  key: 1,
  class: "p-cell-body-menu-item-top"
}
const _hoisted_57 = { class: "p-cell-body-menu-item-bottom" }
const _hoisted_58 = {
  key: 1,
  class: "m-0"
}
const _hoisted_59 = { class: "d-flex" }
const _hoisted_60 = { class: "p-row-title-text" }
const _hoisted_61 = { class: "p-column-title-text" }
const _hoisted_62 = {
  class: "p-cell-body-component",
  style: {"width":"calc(100% - 1.7rem)"}
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 2 }
const _hoisted_67 = { key: 3 }
const _hoisted_68 = { key: 4 }
const _hoisted_69 = { key: 5 }
const _hoisted_70 = { key: 6 }
const _hoisted_71 = { key: 7 }
const _hoisted_72 = { key: 8 }
const _hoisted_73 = { key: 9 }
const _hoisted_74 = { key: 10 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  key: 0,
  class: "p-cell-body-menu",
  style: {"width":"1.5rem"}
}
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-12 p-4" }
const _hoisted_80 = { class: "row mb-3" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Header:")
], -1)
const _hoisted_82 = { class: "col-md-8" }
const _hoisted_83 = { class: "col-form-label" }
const _hoisted_84 = { class: "row mb-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Formula:")
], -1)
const _hoisted_86 = { class: "col-md-7" }
const _hoisted_87 = {
  class: "col-md-1",
  style: {"width":"1.5rem"}
}
const _hoisted_88 = { class: "row mb-3" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Available Function:")
], -1)
const _hoisted_90 = { class: "col-md-7" }
const _hoisted_91 = { class: "row mb-3" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "From Sheet:")
], -1)
const _hoisted_93 = { class: "col-md-7" }
const _hoisted_94 = {
  key: 0,
  class: "row flex align-items-center"
}
const _hoisted_95 = { class: "col-md-3" }
const _hoisted_96 = { class: "col-md-9" }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-md-3" }
const _hoisted_100 = { class: "col-md-9" }
const _hoisted_101 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center pe-5" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "No available sheet to navigate")
], -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { class: "col-md-12 mt-2 d-flex" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-flex justify-content-start" }, null, -1)
const _hoisted_106 = { class: "col-md-6 d-flex justify-content-end" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-md-12 p-4" }
const _hoisted_110 = { class: "row mb-3" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Value:")
], -1)
const _hoisted_112 = { class: "col-md-7" }
const _hoisted_113 = {
  class: "col-md-1",
  style: {"width":"1.5rem"}
}
const _hoisted_114 = { class: "row mb-3" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "From RPK Sheet:")
], -1)
const _hoisted_116 = { class: "col-md-7" }
const _hoisted_117 = {
  key: 0,
  class: "row flex align-items-center"
}
const _hoisted_118 = { class: "col-md-3" }
const _hoisted_119 = { class: "col-md-9" }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-md-3" }
const _hoisted_123 = { class: "col-md-9" }
const _hoisted_124 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center pe-5" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "No available sheet to navigate")
], -1)
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = { class: "col-md-12 mt-2 d-flex" }
const _hoisted_128 = { class: "col-md-6 d-flex justify-content-start" }
const _hoisted_129 = { class: "col-md-6 d-flex justify-content-end" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheStyle = _resolveComponent("TheStyle")!
  const _component_TheCellSettings = _resolveComponent("TheCellSettings")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TheDateTimeDropdown = _resolveComponent("TheDateTimeDropdown")!
  const _component_TheNumberDropdown = _resolveComponent("TheNumberDropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      class: "p-dialog-maximized template-dialog",
      visible: _ctx.isVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
      draggable: false,
      style: {width: '80vw'},
      closable: false,
      onShow: _ctx.setKeyPressDetection,
      onHide: _ctx.removeKeyPressDetection
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.contentIndex == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.headerCode) + " - " + _toDisplayString(_ctx.header), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.navigateValue.code) + " - " + _toDisplayString(_ctx.navigateValue.name), 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Menu, {
                  ref: "rowMenu",
                  model: _ctx.rowMenuItems,
                  popup: true
                }, null, 8, ["model"]),
                _createVNode(_component_Menu, {
                  ref: "columnMenu",
                  model: _ctx.columnMenuItems,
                  popup: true
                }, null, 8, ["model"]),
                _createVNode(_component_Menu, {
                  ref: "cellMenu",
                  model: _ctx.cellMenuItems,
                  popup: true
                }, null, 8, ["model"]),
                (_ctx.contentIndex == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (this.identifier == null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_ctx.isLoading)
                              ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_Button, {
                              class: "p-button-sm",
                              onClick: _ctx.save,
                              label: "Save",
                              disabled: _ctx.isLoading || _ctx.isPageLoading
                            }, null, 8, ["onClick", "disabled"]),
                            _hoisted_12,
                            _createVNode(_component_Button, {
                              class: "p-button-sm",
                              onClick: _ctx.preview,
                              label: "Preview",
                              disabled: _ctx.isLoading || _ctx.isPageLoading
                            }, null, 8, ["onClick", "disabled"]),
                            _createVNode(_component_Button, {
                              class: "p-dialog-header-icons",
                              icon: "pi pi-times",
                              severity: "secondary",
                              text: "",
                              rounded: "",
                              onClick: _ctx.cancel,
                              "aria-label": "Cancel",
                              disabled: _ctx.isPageLoading
                            }, null, 8, ["onClick", "disabled"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.isLoading)
                              ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_Button, {
                              class: "p-button-sm p-button-warning",
                              label: (this.publishedDate == null ? 'Draft' : 'Published') + ' Version ' + this.version,
                              disabled: true
                            }, null, 8, ["label"]),
                            _hoisted_14,
                            (this.publishedDate == null)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  class: "p-button-sm",
                                  onClick: _ctx.update,
                                  label: "Save",
                                  disabled: _ctx.isLoading || _ctx.isPageLoading
                                }, null, 8, ["onClick", "disabled"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_Button, {
                              class: "p-dialog-header-icons",
                              icon: "pi pi-times",
                              severity: "secondary",
                              text: "",
                              rounded: "",
                              onClick: _ctx.cancel,
                              "aria-label": "Cancel",
                              disabled: _ctx.isPageLoading
                            }, null, 8, ["onClick", "disabled"])
                          ]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _ctx.onNavigateBack,
                          label: "Back",
                          disabled: _ctx.isPageLoading
                        }, null, 8, ["onClick", "disabled"]),
                        _createVNode(_component_Button, {
                          class: "p-dialog-header-icons",
                          icon: "pi pi-times",
                          severity: "secondary",
                          text: "",
                          rounded: "",
                          onClick: _ctx.cancel,
                          "aria-label": "Cancel",
                          disabled: _ctx.isPageLoading
                        }, null, 8, ["onClick", "disabled"])
                      ])
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_ctx.contentIndex == 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle({'visibility': _ctx.isShowFormulaHeader ? 'visible' : 'hidden'})
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.cellTitleHeader), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.formulaHeader), 1)
                    ])
                  ], 4))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.styleComponent.visible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_TheStyle, {
                    reloadKey: (_ctx.styleComponent.rowIndex + '' + _ctx.styleComponent.columnIndex),
                    cssStyle: _ctx.styleComponent.style,
                    onUpdateStyleEvent: _ctx.updateStyle,
                    onUpdateSettingsEvent: _ctx.updateSettings
                  }, null, 8, ["reloadKey", "cssStyle", "onUpdateStyleEvent", "onUpdateSettingsEvent"]),
                  _createVNode(_component_TheCellSettings, {
                    styleComponent: _ctx.styleComponent,
                    onUpdateSettingsEvent: _ctx.updateSettings
                  }, null, 8, ["styleComponent", "onUpdateSettingsEvent"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.isPageLoading)
            ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isPageLoading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass('zoom-template-' + parseInt(_ctx.zoomLevel * 100))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: "m-auto d-flex align-items-center justify-content-center position-relative",
                      style: _normalizeStyle({'width': _ctx.tableWidth + 'rem'})
                    }, [
                      _createVNode(_component_DataTable, {
                        class: "p-datatable-template p-datatable-template-header-only",
                        value: [],
                        showGridlines: "",
                        tableClass: "editable-cells-table",
                        style: _normalizeStyle({'width': _ctx.tableWidth + 'rem'})
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            field: "",
                            header: "",
                            class: "p-template-column-number"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("span", _hoisted_24, _toDisplayString(slotProps.index + 1), 1)
                              ])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnHeaders, (column, columnIndex) => {
                            return (_openBlock(), _createBlock(_component_Column, {
                              key: column.header,
                              field: column.header,
                              header: column.header,
                              style: _normalizeStyle({'width': (columnIndex != 0 ? 9 : 27) + 'rem', 'max-width': (columnIndex != 0 ? 9 : 27) + 'rem'})
                            }, {
                              header: _withCtx(() => [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(column.header), 1),
                                (this.publishedDate == null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createVNode(_component_Button, {
                                        icon: "pi pi-chevron-down",
                                        class: "p-button-secondary p-button-title-collapsible",
                                        onClick: ($event: any) => (_ctx.toggleColumnMenu($event, columnIndex))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["field", "header", "style"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ], 4)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass({'d-flex' : _ctx.isHorizontalScrollbar}),
                    style: _normalizeStyle({'width': !_ctx.isHorizontalScrollbar ? 'auto' : (_ctx.tableWidth + (_ctx.contents[_ctx.contentIndex].template == null ? 0 : (_ctx.contents[_ctx.contentIndex].template[0].columns.length * (parseInt(_ctx.zoomLevel * 10) - 10))) + 'rem')})
                  }, [
                    (_ctx.isHorizontalScrollbar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_DataTable, {
                            class: "p-datatable-template p-datatable-template-body-only",
                            value: _ctx.contents[_ctx.contentIndex].template,
                            showGridlines: "",
                            tableClass: "editable-cells-table"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "index",
                                header: "",
                                class: "p-template-column-number"
                              }, {
                                body: _withCtx((slotProps) => [
                                  _withDirectives((_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["d-flex", _ctx.getBorder(slotProps.index)])
                                  }, [
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(slotProps.index + 1), 1),
                                    (this.publishedDate == null)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                          _createVNode(_component_Button, {
                                            icon: "pi pi-chevron-down",
                                            class: "p-button-secondary p-button-title-collapsible",
                                            onClick: ($event: any) => (_ctx.toggleRowMenu($event, slotProps.index))
                                          }, null, 8, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2)), [
                                    [
                                      _directive_tooltip,
                                      _ctx.contents[_ctx.contentIndex].template[slotProps.index].columns[0].value,
                                      void 0,
                                      { right: true }
                                    ]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "m-auto d-flex align-items-center justify-content-center position-relative",
                        style: _normalizeStyle({'width': _ctx.tableWidth + 'rem'}),
                        key: index
                      }, [
                        (index == _ctx.contentIndex)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                (_ctx.contentIndex == 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createVNode(_component_DataTable, {
                                        class: "p-datatable-template p-datatable-template-body-only",
                                        value: _ctx.contents[_ctx.contentIndex].template,
                                        showGridlines: "",
                                        tableClass: "editable-cells-table",
                                        style: _normalizeStyle({'width': _ctx.tableWidth - (_ctx.isHorizontalScrollbar ? 4 : 0) + (content.template[0].columns.length * (parseInt(_ctx.zoomLevel * 10) - 10)) + 'rem'})
                                      }, {
                                        default: _withCtx(() => [
                                          (!_ctx.isHorizontalScrollbar)
                                            ? (_openBlock(), _createBlock(_component_Column, {
                                                key: 0,
                                                field: "",
                                                header: "",
                                                class: "p-template-column-number"
                                              }, {
                                                body: _withCtx((slotProps) => [
                                                  _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("span", _hoisted_34, _toDisplayString(slotProps.index + 1), 1),
                                                    (this.publishedDate == null)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                          _createVNode(_component_Button, {
                                                            icon: "pi pi-chevron-down",
                                                            class: "p-button-secondary p-button-title-collapsible",
                                                            onClick: ($event: any) => (_ctx.toggleRowMenu($event, slotProps.index))
                                                          }, null, 8, ["onClick"])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnHeaders, (column, columnIndex) => {
                                            return (_openBlock(), _createBlock(_component_Column, {
                                              key: column.header,
                                              field: column.header,
                                              header: column.header,
                                              class: "p-template-column-cell",
                                              style: _normalizeStyle([{'width': (columnIndex != 0 ? 9 : 27) + 'rem', 'max-width': (columnIndex != 0 ? 9 : 27) + 'rem', 'padding': '0px'}]),
                                              pt: {
													bodycell: ({ parent, props }) => ({
														colspan: _ctx.getCellColspan(parent.props.rowIndex, columnIndex),
														style: _ctx.getCellDisplay(parent.props.rowIndex, columnIndex),
													})
												}
                                            }, {
                                              header: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_36, _toDisplayString(column.header), 1),
                                                (this.publishedDate == null)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                      _createVNode(_component_Button, {
                                                        icon: "pi pi-chevron-down",
                                                        class: "p-button-secondary p-button-title-collapsible",
                                                        onClick: ($event: any) => (_ctx.toggleColumnMenu($event, columnIndex))
                                                      }, null, 8, ["onClick"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              body: _withCtx((slotProps) => [
                                                _createElementVNode("div", {
                                                  style: _normalizeStyle((slotProps.data.columns[columnIndex] == null ? null : slotProps.data.columns[columnIndex].style)),
                                                  class: _normalizeClass(["row col-md-12 p-cell-body", column.header + (slotProps.index + 1)])
                                                }, [
                                                  _createElementVNode("div", _hoisted_38, [
                                                    (slotProps.data.columns != null && slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null)
                                                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                          (slotProps.data.columns[columnIndex].component == 'FORMULA' || slotProps.data.columns[columnIndex].component == 'VALUE' || slotProps.data.columns[columnIndex].component == 'NAVIGATE')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                                _createElementVNode("div", {
                                                                  class: "p-inputgroup",
                                                                  onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex))
                                                                }, [
                                                                  _createVNode(_component_InputText, {
                                                                    modelValue: slotProps.data.columns[columnIndex].value,
                                                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                    disabled: this.publishedDate != null,
                                                                    onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocus"]),
                                                                  _createVNode(_component_Button, {
                                                                    icon: "pi pi-align-justify",
                                                                    severity: "warning",
                                                                    disabled: this.publishedDate != null,
                                                                    onClick: ($event: any) => (slotProps.data.columns[columnIndex].component == 'FORMULA' ? _ctx.openFormulaDialog(slotProps.index, columnIndex, false) : _ctx.openValueDialog(slotProps.index, columnIndex))
                                                                  }, null, 8, ["disabled", "onClick"])
                                                                ], 40, _hoisted_41)
                                                              ]))
                                                            : (slotProps.data.columns[columnIndex].component == 'LABEL')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                                  _createVNode(_component_InputText, {
                                                                    modelValue: slotProps.data.columns[columnIndex].value,
                                                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                    disabled: this.publishedDate != null,
                                                                    onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                    onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                ]))
                                                              : (slotProps.data.columns[columnIndex].component == 'HEADER')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                                    _createVNode(_component_InputText, {
                                                                      modelValue: slotProps.data.columns[columnIndex].value,
                                                                      "onUpdate:modelValue": [($event: any) => ((slotProps.data.columns[columnIndex].value) = $event), ($event: any) => (_ctx.updateHeader(columnIndex, true))],
                                                                      disabled: this.publishedDate != null,
                                                                      onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex))
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin"])
                                                                  ]))
                                                                : (slotProps.data.columns[columnIndex].component == 'LONGLABEL')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                                      _createVNode(_component_InputText, {
                                                                        modelValue: slotProps.data.columns[columnIndex].value,
                                                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                        disabled: this.publishedDate != null,
                                                                        onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                        onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                    ]))
                                                                  : (slotProps.data.columns[columnIndex].component == 'DATETIME')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                                        _createVNode(_component_TheDateTimeDropdown, {
                                                                          modelValue: slotProps.data.columns[columnIndex].value,
                                                                          "onUpdate:modelValue": value => slotProps.data.columns[columnIndex].value = value,
                                                                          disabled: _ctx.publishedDate != null,
                                                                          onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                          onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                      ]))
                                                                    : (slotProps.data.columns[columnIndex].component == 'NUMBER')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                                          _createVNode(_component_TheNumberDropdown, {
                                                                            modelValue: slotProps.data.columns[columnIndex].value,
                                                                            "onUpdate:modelValue": value => slotProps.data.columns[columnIndex].value = value,
                                                                            disabled: _ctx.publishedDate != null,
                                                                            onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                            onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                        ]))
                                                                      : (slotProps.data.columns[columnIndex].component == 'TEXT' || slotProps.data.columns[columnIndex].component == 'HEADERTEXT')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                                            _createVNode(_component_InputText, {
                                                                              modelValue: slotProps.data.columns[columnIndex].value,
                                                                              "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                              disabled: this.publishedDate != null,
                                                                              onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                              onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                          ]))
                                                                        : (slotProps.data.columns[columnIndex].component == 'LONGTEXT')
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                                              _createVNode(_component_InputText, {
                                                                                modelValue: slotProps.data.columns[columnIndex].value,
                                                                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                                disabled: this.publishedDate != null,
                                                                                onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                                onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                            ]))
                                                                          : (slotProps.data.columns[columnIndex].component == 'COMPANY')
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                                                _createVNode(_component_InputText, {
                                                                                  modelValue: slotProps.data.columns[columnIndex].value,
                                                                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                                  placeholder: "Company",
                                                                                  disabled: this.publishedDate != null,
                                                                                  onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                                  readonly: "",
                                                                                  onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                              ]))
                                                                            : (slotProps.data.columns[columnIndex].component == 'COMPANYDROPDOWN')
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                                                  _createVNode(_component_InputText, {
                                                                                    modelValue: slotProps.data.columns[columnIndex].value,
                                                                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                                    placeholder: "Company Dropdown",
                                                                                    disabled: this.publishedDate != null,
                                                                                    onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                                    readonly: "",
                                                                                    onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                                ]))
                                                                              : (slotProps.data.columns[columnIndex].component == 'COUNTRY')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                                                    _createVNode(_component_InputText, {
                                                                                      modelValue: slotProps.data.columns[columnIndex].value,
                                                                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                                      placeholder: "Country",
                                                                                      disabled: this.publishedDate != null,
                                                                                      onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                                      readonly: "",
                                                                                      onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                                  ]))
                                                                                : (slotProps.data.columns[columnIndex].component == 'CURRENCY')
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                                                      _createVNode(_component_InputText, {
                                                                                        modelValue: slotProps.data.columns[columnIndex].value,
                                                                                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                                                        placeholder: "Currency",
                                                                                        disabled: this.publishedDate != null,
                                                                                        onFocusin: ($event: any) => (_ctx.inputFocus(slotProps.index, columnIndex)),
                                                                                        readonly: "",
                                                                                        onFocus: ($event: any) => (_ctx.onChangeCellFormulaAndHeader(slotProps.index, column.header, slotProps.data.columns[columnIndex]))
                                                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onFocusin", "onFocus"])
                                                                                    ]))
                                                                                  : _createCommentVNode("", true)
                                                        ])), [
                                                          [
                                                            _directive_tooltip,
                                                            {value: slotProps.data.columns[columnIndex].component, disabled: slotProps.data.columns[columnIndex].component == null},
                                                            void 0,
                                                            { top: true }
                                                          ]
                                                        ])
                                                      : (slotProps.data.columns != null && slotProps.data.columns[columnIndex] != null)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                            _createVNode(_component_InputText, {
                                                              modelValue: slotProps.data.columns[columnIndex].value,
                                                              "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                              style: {"visibility":"hidden"}
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                  ]),
                                                  (_ctx.publishedDate == null)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                        _createElementVNode("div", null, [
                                                          (slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component == null && this.publishedDate == null)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                _createVNode(_component_Button, {
                                                                  icon: "pi pi-chevron-down",
                                                                  class: "p-button-primary p-button-cell-collapsible",
                                                                  onClick: ($event: any) => (_ctx.toggleCellMenu($event, slotProps.field + (slotProps.index + 1)))
                                                                }, null, 8, ["onClick"])
                                                              ]))
                                                            : (slotProps.data.columns[columnIndex] != null && this.publishedDate == null)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                                  _createVNode(_component_Button, {
                                                                    icon: "pi pi-times",
                                                                    class: "p-button-danger p-button-cell-collapsible",
                                                                    onClick: ($event: any) => (_ctx.removeCellComponent(slotProps.field + (slotProps.index + 1), slotProps.data.columns[columnIndex].component))
                                                                  }, null, 8, ["onClick"])
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                          _createElementVNode("div", _hoisted_57, [
                                                            _createVNode(_component_Button, {
                                                              icon: "pi pi-palette",
                                                              class: "p-button-primary p-button-cell-collapsible",
                                                              onClick: ($event: any) => (_ctx.showStyle(slotProps.index, columnIndex, false))
                                                            }, null, 8, ["onClick"])
                                                          ])
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 6)
                                              ]),
                                              _: 2
                                            }, 1032, ["field", "header", "style", "pt"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "style"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _createVNode(_component_DataTable, {
                                        class: "p-datatable-template p-datatable-template-body-only",
                                        value: _ctx.contents[_ctx.contentIndex].template,
                                        showGridlines: "",
                                        tableClass: "editable-cells-table",
                                        style: _normalizeStyle({'width': _ctx.tableWidth - (_ctx.isHorizontalScrollbar ? 4 : 0) + (content.template[0].columns.length * (parseInt(_ctx.zoomLevel * 10) - 10)) + 'rem'})
                                      }, {
                                        default: _withCtx(() => [
                                          (!_ctx.isHorizontalScrollbar)
                                            ? (_openBlock(), _createBlock(_component_Column, {
                                                key: 0,
                                                field: "",
                                                header: "",
                                                class: "p-template-column-number"
                                              }, {
                                                body: _withCtx((slotProps) => [
                                                  _createElementVNode("div", _hoisted_59, [
                                                    _createElementVNode("span", _hoisted_60, _toDisplayString(slotProps.index + 1), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnHeaders, (column, columnIndex) => {
                                            return (_openBlock(), _createBlock(_component_Column, {
                                              key: column.header,
                                              field: column.header,
                                              header: column.header,
                                              class: "p-template-column-cell",
                                              style: _normalizeStyle([{'width': (columnIndex != 0 ? 9 : 27) + 'rem', 'max-width': (columnIndex != 0 ? 9 : 27) + 'rem', 'padding': '0px'}]),
                                              pt: {
													bodycell: ({ parent, props }) => ({
														colspan: _ctx.getCellColspan(parent.props.rowIndex, columnIndex),
														style: _ctx.getCellDisplay(parent.props.rowIndex, columnIndex),
													})
												}
                                            }, {
                                              header: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_61, _toDisplayString(column.header), 1)
                                              ]),
                                              body: _withCtx((slotProps) => [
                                                _createElementVNode("div", {
                                                  style: _normalizeStyle((slotProps.data.columns[columnIndex] == null ? null : slotProps.data.columns[columnIndex].style)),
                                                  class: _normalizeClass(["row col-md-12 p-cell-body", column.header + (slotProps.index + 1)])
                                                }, [
                                                  _createElementVNode("div", _hoisted_62, [
                                                    (slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                          (slotProps.data.columns[columnIndex].component == 'FORMULA' || slotProps.data.columns[columnIndex].component == 'VALUE' || slotProps.data.columns[columnIndex].component == 'NAVIGATE')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                                _createVNode(_component_InputText, {
                                                                  modelValue: slotProps.data.columns[columnIndex].value,
                                                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event)
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                              ]))
                                                            : (slotProps.data.columns[columnIndex].component == 'LABEL')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                                  _createElementVNode("label", null, _toDisplayString(slotProps.data.columns[columnIndex].value), 1)
                                                                ]))
                                                              : (slotProps.data.columns[columnIndex].component == 'LONGLABEL')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                                    _createElementVNode("label", null, _toDisplayString(slotProps.data.columns[columnIndex].value), 1)
                                                                  ]))
                                                                : (slotProps.data.columns[columnIndex].component == 'DATETIME')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                                      _createVNode(_component_TheDateTimeDropdown, {
                                                                        modelValue: slotProps.data.columns[columnIndex].value,
                                                                        disabled: true
                                                                      }, null, 8, ["modelValue"])
                                                                    ]))
                                                                  : (slotProps.data.columns[columnIndex].component == 'NUMBER')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                                        _createVNode(_component_TheNumberDropdown, {
                                                                          modelValue: slotProps.data.columns[columnIndex].value,
                                                                          disabled: true
                                                                        }, null, 8, ["modelValue"])
                                                                      ]))
                                                                    : (slotProps.data.columns[columnIndex].component == 'TEXT')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                                                          _createVNode(_component_InputText, {
                                                                            modelValue: slotProps.data.columns[columnIndex].value,
                                                                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event)
                                                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                        ]))
                                                                      : (slotProps.data.columns[columnIndex].component == 'LONGTEXT')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                                            _createVNode(_component_InputText, {
                                                                              modelValue: slotProps.data.columns[columnIndex].value,
                                                                              "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event)
                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                          ]))
                                                                        : (slotProps.data.columns[columnIndex].component == 'COMPANY')
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                                              _createVNode(_component_InputText, {
                                                                                modelValue: slotProps.data.columns[columnIndex].value,
                                                                                "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event)
                                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                            ]))
                                                                          : (slotProps.data.columns[columnIndex].component == 'COMPANYDROPDOWN')
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                                                                _createVNode(_component_InputText, {
                                                                                  modelValue: slotProps.data.columns[columnIndex].value,
                                                                                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event)
                                                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                              ]))
                                                                            : (slotProps.data.columns[columnIndex].component == 'COUNTRY')
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                                                                  _createVNode(_component_InputText, {
                                                                                    modelValue: slotProps.data.columns[columnIndex].value,
                                                                                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event)
                                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                                ]))
                                                                              : (slotProps.data.columns[columnIndex].component == 'CURRENCY')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                                                                    _createVNode(_component_InputText, {
                                                                                      modelValue: slotProps.data.columns[columnIndex].value,
                                                                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event)
                                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                                                  ]))
                                                                                : _createCommentVNode("", true)
                                                        ]))
                                                      : (slotProps.data.columns[columnIndex] != null)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                            _createVNode(_component_InputText, {
                                                              modelValue: slotProps.data.columns[columnIndex].value,
                                                              "onUpdate:modelValue": ($event: any) => ((slotProps.data.columns[columnIndex].value) = $event),
                                                              style: {"visibility":"hidden"}
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                  ]),
                                                  (_ctx.publishedDate == null)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                        (slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && (slotProps.data.columns[columnIndex].component == 'FORMULA' || slotProps.data.columns[columnIndex].component == 'TEXT' || slotProps.data.columns[columnIndex].component == 'NUMBER' || slotProps.data.columns[columnIndex].component == 'NAVIGATE') && !_ctx.navigateCell)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                              _createVNode(_component_Button, {
                                                                icon: "pi pi-check",
                                                                class: "p-button-success p-button-cell-collapsible",
                                                                onClick: ($event: any) => (_ctx.navigateCellComponent(slotProps.field + (slotProps.index + 1)))
                                                              }, null, 8, ["onClick"])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 6)
                                              ]),
                                              _: 2
                                            }, 1032, ["field", "header", "style", "pt"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "style"])
                                    ]))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 4))
                    }), 128))
                  ], 6)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onShow", "onHide"]),
    _createVNode(_component_Dialog, {
      header: "Formula",
      visible: _ctx.formulaDialog.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formulaDialog.visible) = $event)),
      draggable: false,
      style: { width: '50vw' },
      onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeFormula())),
      onMousemove: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onFormulaMouseMove()))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_104, [
          _hoisted_105,
          _createElementVNode("div", _hoisted_106, [
            _createVNode(_component_Button, {
              class: "p-button-text p-button-sm",
              label: "Cancel",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeFormula()))
            }),
            _hoisted_107,
            _createVNode(_component_Button, {
              class: "p-button-sm",
              label: "Save",
              onClick: _ctx.saveFormula
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _hoisted_81,
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.formulaDialog.header), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _hoisted_85,
              _createElementVNode("div", _hoisted_86, [
                _createVNode(_component_InputText, {
                  id: "formula-input-text",
                  class: "p-inputtext",
                  type: "text",
                  modelValue: _ctx.formulaDialog.formula,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formulaDialog.formula) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_Button, {
                  icon: "pi pi-chevron-right",
                  class: "p-button-success p-button-cell-collapsible",
                  disabled: _ctx.formulaDialog.formula == null || _ctx.formulaDialog.formula == '',
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateCellComponent(null)))
                }, null, 8, ["disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              _createElementVNode("div", _hoisted_90, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.formulaDialog.selectedFormula,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formulaDialog.selectedFormula) = $event)),
                  options: _ctx.formulas,
                  optionLabel: "name",
                  optionValue: "value",
                  placeholder: "-- Please Select --",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.appendFormula(null)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.formulaDialog.selectedNavigate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formulaDialog.selectedNavigate) = $event)),
                  filter: "",
                  options: _ctx.sheets,
                  optionLabel: "code",
                  placeholder: "Select a Sheet",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onNavigateChange(this.formulaDialog.rowIndex, this.formulaDialog.columnIndex))),
                  autoOptionFocus: true,
                  filterFields: ['code','name']
                }, {
                  value: _withCtx((dropdownProps) => [
                    (dropdownProps.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                          _createElementVNode("span", _hoisted_95, _toDisplayString(dropdownProps.value.code), 1),
                          _createElementVNode("span", _hoisted_96, _toDisplayString(dropdownProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(dropdownProps.placeholder), 1))
                  ]),
                  option: _withCtx((dropdownProps) => [
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("span", _hoisted_99, _toDisplayString(dropdownProps.option.code), 1),
                      _createElementVNode("span", _hoisted_100, _toDisplayString(dropdownProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            (_ctx.noNavigateSheet)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, _hoisted_103))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: "RPK Value",
      visible: _ctx.valueDialog.visible,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.valueDialog.visible) = $event)),
      draggable: false,
      style: { width: '50vw' },
      onHide: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeValue()))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_127, [
          _createElementVNode("div", _hoisted_128, [
            _createVNode(_component_Button, {
              class: "p-button-sm p-button-warning",
              label: "Clear Value",
              onClick: _ctx.clearValue
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_129, [
            _createVNode(_component_Button, {
              class: "p-button-text p-button-sm",
              label: "Cancel",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.closeValue()))
            }),
            _hoisted_130,
            _createVNode(_component_Button, {
              class: "p-button-sm",
              label: "Save",
              onClick: _ctx.saveValue,
              disabled: _ctx.v$.valueDialog.$invalid
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _hoisted_111,
              _createElementVNode("div", _hoisted_112, [
                _createVNode(_component_InputText, {
                  class: "p-inputtext",
                  type: "text",
                  modelValue: _ctx.valueDialog.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.valueDialog.value) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createVNode(_component_Button, {
                  icon: "pi pi-chevron-right",
                  class: "p-button-success p-button-cell-collapsible",
                  disabled: _ctx.valueDialog.value == null || _ctx.valueDialog.value == '',
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navigateCellComponent(null)))
                }, null, 8, ["disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_114, [
              _hoisted_115,
              _createElementVNode("div", _hoisted_116, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.valueDialog.selectedNavigate,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.valueDialog.selectedNavigate) = $event)),
                  filter: "",
                  options: _ctx.rpkSheets,
                  optionLabel: "code",
                  placeholder: "Select a Sheet",
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onNavigateChange(this.valueDialog.rowIndex, this.valueDialog.columnIndex))),
                  autoOptionFocus: true,
                  filterFields: ['code','name']
                }, {
                  value: _withCtx((dropdownProps) => [
                    (dropdownProps.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                          _createElementVNode("span", _hoisted_118, _toDisplayString(dropdownProps.value.code), 1),
                          _createElementVNode("span", _hoisted_119, _toDisplayString(dropdownProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString(dropdownProps.placeholder), 1))
                  ]),
                  option: _withCtx((dropdownProps) => [
                    _createElementVNode("div", _hoisted_121, [
                      _createElementVNode("span", _hoisted_122, _toDisplayString(dropdownProps.option.code), 1),
                      _createElementVNode("span", _hoisted_123, _toDisplayString(dropdownProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            (_ctx.noNavigateSheet)
              ? (_openBlock(), _createElementBlock("div", _hoisted_124, _hoisted_126))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}